import { toast as base } from 'sonner';
import { sound } from './sound';

/** sonner's toast, with the matching UI sound (when the person has sound on). */
export const toast = Object.assign(((...a: Parameters<typeof base>) => base(...a)) as typeof base, base, {
  success: ((...a: Parameters<typeof base.success>) => { sound.success(); return base.success(...a); }) as typeof base.success,
  error: ((...a: Parameters<typeof base.error>) => { sound.error(); return base.error(...a); }) as typeof base.error,
  warning: ((...a: Parameters<typeof base.warning>) => { sound.alert(); return base.warning(...a); }) as typeof base.warning,
});
